import React from 'react'
import { useSchedule } from '../../context/ScheduleContext'
import ScheduleContextMenuOption from '../contextMenu/ScheduleContextMenuOption'
import { DayType } from '../constants/DayType'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { getColorGroups } from '../helpers/DayTypeTabGroup'
import useDayTypesService from '@/modules/drivers/services/DayTypesService'

const DayTypesContent = ({ companyId }) => {
  const { formTab, setSelectedDayType, selectedDayType } = useSchedule()
  const { getPinnedDays } = useDayTypesService()
  const [pinnedDays, setPinnedDays] = React.useState<DayType[]>([])

  const fetchPinnedDays = React.useCallback(async () => {
    try {
      const data = await getPinnedDays({ companyId })
      setPinnedDays(data)
    } catch (error) {
      console.error('Error fetching pinned days:', error)
    }
  }, [companyId])

  React.useEffect(() => {
    fetchPinnedDays()
  }, [])

  const changeDayType = (type: DayType) => {
    if (selectedDayType && selectedDayType === type) {
      setSelectedDayType(null)
      return
    }
    {
      setSelectedDayType(type)
    }
  }

  const colorGroups = getColorGroups({ formTab })

  return (
    <div className="tw-flex-1 tw-overflow-y-auto">
      {colorGroups.map((group, groupIndex) => (
        <React.Fragment key={groupIndex}>
          {group.map((dayType) => (
            <ScheduleContextMenuOption
              companyId={companyId}
              isSelected={selectedDayType === dayType}
              key={dayType}
              isPinned={pinnedDays.includes(dayType)}
              onPinToggle={fetchPinnedDays}
              dayType={dayType}
              changeDayType={changeDayType}
            />
          ))}
          {groupIndex < colorGroups.length - 1 && <DividerHorizontal />}
        </React.Fragment>
      ))}
    </div>
  )
}

export default DayTypesContent
